
import React from "react";
import oruclicksLogo from "../../../Assets/images/oruclicks-logo.svg";

// Oruclicks logo component (SVG asset)
const CLogo = ({
  size = "45px",
  textSize = "24px",
  showText = true,
  iconOnly = false,
  isDarkTheme = false,
  appName = "Contacts",
  onClick,
  className,
  style
}) => {
  const resolvedSize = typeof size === "number" ? `${size}px` : size;
  const resolvedTextSize = typeof textSize === "number" ? `${textSize}px` : textSize;

  return (
    <div
      onClick={onClick}
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "10px",
        cursor: onClick ? "pointer" : "default",
        ...style
      }}
    >
      <img
        src={oruclicksLogo}
        alt="OruClick Logo"
        width={resolvedSize}
        height={resolvedSize}
        style={{
          display: "block",
          filter: isDarkTheme ? "brightness(1.15)" : "none"
        }}
      />
      {!iconOnly && showText && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            fontFamily: "Manrope, Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
            textRendering: "optimizeLegibility"
          }}
        >
          <span
            style={{
              fontSize: `calc(${resolvedTextSize} * 0.55)`,
              fontWeight: 500,
              lineHeight: 1.2,
              color: isDarkTheme ? "#CBD5E1" : "#475569"
            }}
          >
            OruClick
          </span>
          <span
            style={{
              fontSize: resolvedTextSize,
              fontWeight: 800,
              lineHeight: 1.1,
              letterSpacing: "-0.2px",
              color: isDarkTheme ? "#FFFFFF" : "#0F172A"
            }}
          >
            {appName}
          </span>
        </div>
      )}
    </div>
  );
};

export default CLogo;
